export function InRequest(params = {}) {
  return {
    type: '@servicedlgrelestoque/IN_REQUEST',
    payload: { params },
  };
}

export function findRecord(post_cod_posto) {
  return {
    type: '@servicedlgrelestoque/FIND',
    payload: { post_cod_posto },
  };
}

export function failedRequest() {
  return {
    type: '@servicedlgrelestoque/FAILED_REQUEST',
  };
}

export function deleteRecord(post_cod_posto, params) {
  return {
    type: '@servicedlgrelestoque/DELETE',
    payload: { post_cod_posto, params },
  };
}

export function updateRecord(servicedlgrelestoque, params) {
  return {
    type: '@servicedlgrelestoque/UPDATE',
    payload: { servicedlgrelestoque, params },
  };
}

export function storeRecord(servicedlgrelestoque, params) {
  return {
    type: '@servicedlgrelestoque/STORE',
    payload: { servicedlgrelestoque, params },
  };
}

export function successInRequest(
  servicedlgrelestoque,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@servicedlgrelestoque/SUCCESS_IN_REQUEST',
    payload: { servicedlgrelestoque, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(servicedlgrelestoque) {
  return {
    type: '@servicedlgrelestoque/SUCCESS_REQUEST',
    payload: { servicedlgrelestoque },
  };
}

export function successRemove(params) {
  return {
    type: '@servicedlgrelestoque/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@servicedlgrelestoque/RECORD_FILTERING',
    payload: { params },
  };
}
